export default __webpack_public_path__ + "static/media/featSportBgMb.0533998c.png";